// TEMPORARY PLACEHOLDER VIDEOS - REPLACE WITH YOUR OWN VERTICAL (9:16) VIDEOS
// 
// These are PUBLIC SAMPLE VIDEOS used as temporary placeholders
// Replace these URLs with your own cinematic vertical videos
// 
// Required specs for your videos:
// - Aspect ratio: 9:16 (vertical - Instagram/TikTok/Reels format)
// - Duration: 5-6 seconds
// - Style: Cinematic abstract motion (light leaks, grain, particles, film textures)
// - Format: MP4 or WebM
// - No faces, no burned-in text
// 
// Option 1: Store locally
//   - Place videos in /public/videos/ folder
//   - Update videoUrl to: "/videos/placeholder-1.mp4"
// 
// Option 2: Use hosted URLs
//   - Upload to Vimeo/Cloudflare/Bunny
//   - Replace with full URLs below

export const portfolioVideos = [
  {
    id: 1,
    videoUrl: "https://customer-assets.emergentagent.com/job_aiadmitra-films/artifacts/ryfrxjrf_developer-7.mp4",
    title: "Brand Film",
    caption: "Cinematic Brand Story",
  },
  {
    id: 2,
    videoUrl: "https://customer-assets.emergentagent.com/job_aiadmitra-films/artifacts/xx1l5zu9_iswarya%20infertility.mp4",
    title: "AI Ad",
    caption: "Emotional AI Campaign",
  },
  {
    id: 3,
    videoUrl: "https://customer-assets.emergentagent.com/job_aiadmitra-films/artifacts/akb69wy6_Untitle%29.mp4",
    title: "Story Film",
    caption: "Visual Storytelling",
  },
];

export const heroVideo = {
  videoUrl: "https://customer-assets.emergentagent.com/job_aiadmitra-films/artifacts/jovlaql1_AIADMITRA.mp4",
};
